import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import Icon from '../../Icon';
import {
  fillCategoriesWithData,
  getCategoriesData
} from '../../../utils/helpers/search';
import { categoriesQuery } from '../../../queries';
import useBugsnagNotifier from '../../../hooks/useBugsnagNotifier';

const NewSearchCategory = ({ icon, text, onClick, stat }) => {
  return (
    <div
      tabIndex={0}
      role="button"
      data-stat={stat}
      onClick={onClick}
      onKeyPress={onClick}
      className="category-container"
    >
      <div className="category__icon">
        <Icon
          width={22}
          height={22}
          color="#fff"
          indent={false}
          IconComponent={icon}
        />
      </div>
      <span className="category__text">{text}</span>
    </div>
  );
};

NewSearchCategory.propTypes = {
  icon: PropTypes.func,
  stat: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func
};

const NewSearchCategories = ({ change, submit }) => {
  const { data, error } = useQuery(categoriesQuery);
  const {
    i18n: { language }
  } = useTranslation();
  const categoriesData = getCategoriesData({ data, language });
  const filledCategories = fillCategoriesWithData(categoriesData);

  useBugsnagNotifier(error);

  return (
    <div className="categories-container">
      {filledCategories.map(category => (
        <NewSearchCategory
          key={category.id}
          stat={category.stat}
          icon={category.icon}
          text={category.name}
          onClick={() => {
            change('category_id', category.id);
            change('category_touched', true);
            submit();
          }}
        />
      ))}
    </div>
  );
};

NewSearchCategories.propTypes = {
  change: PropTypes.func,
  submit: PropTypes.func
};

export default NewSearchCategories;
